import ManualExpenseDetails from '../../../../components/Finance/ProvidersExpenses/ManualExpense/ManualExpenseTable/ManualExpenseDetails'


const FinanceManualExpenseDetailScreen = () => {
  return (
    <>
      <ManualExpenseDetails />
    </>
  )
}

export default FinanceManualExpenseDetailScreen
